import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { SearchResultCard } from './search-result-card'
import { Search } from 'lucide-react'

interface Profile {
  title: string
  snippet: string
  followers: number
  url: string
}

interface SearchResultsProps {
  profiles: Profile[]
  totalProfiles: number
}

export function SearchResults({ profiles, totalProfiles }: SearchResultsProps) {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="pb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10 flex-shrink-0">
              <Search className="h-4 w-4 text-primary" />
            </div>
            <div className="flex-1">
              <CardTitle className="text-lg font-semibold">Search Results</CardTitle>
              <div className="flex items-center gap-2 mt-1">
                <CardDescription>
                  Found {totalProfiles} matching profiles
                </CardDescription>
                <Badge variant="secondary" className="text-xs">
                  Live
                </Badge>
              </div>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="space-y-3">
            {profiles.map((profile, index) => (
              <div key={index}>
                <SearchResultCard
                  title={profile.title}
                  snippet={profile.snippet}
                  followers={profile.followers}
                  url={profile.url}
                />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
} 